module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'is-selected': _vm.itemData.selected, 'error': _vm.itemData.error
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.select($event)
      }
    }
  }, [_c('span', {
    staticClass: "arrow_to_move",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "material-icons pointerClass",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.moveItemUp($event)
      }
    }
  }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons pointerClass",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.moveItemDown($event)
      }
    }
  }, [_vm._v("keyboard_arrow_down")])]), _vm._v(" "), _c('p', {
    staticClass: "d-inline-block",
    class: {
      bold: _vm.itemData.items && _vm.itemData.items.length > 0
    }
  }, [(_vm.itemData.colorCode) ? _c('span', {
    staticClass: "color-preview",
    style: ({
      'background-color': _vm.itemData.colorCode
    })
  }) : _vm._e(), _vm._v(" "), (_vm.itemData.abbr) ? _c('small', [_vm._v("(" + _vm._s(_vm.itemData.abbr[_vm.language]) + ")")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.itemData.name[_vm.language]) + " "), (_vm.itemData.itemId) ? _c('small', [_vm._v("[" + _vm._s(_vm.itemData.itemId) + "]")]) : _vm._e(), _vm._v(" "), _c('small', [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.header.views) + ": " + _vm._s(_vm.formattedViews) + "\n      "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.printerCategories) + ": " + _vm._s(_vm.formattedPrintCategories) + "\n      "), (_vm.formattedSettings) ? [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.settings) + ": " + _vm._s(_vm.formattedSettings))] : _vm._e(), _vm._v(" "), [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.VAT) + ": " + _vm._s(_vm.itemData.vatRate ? _vm.itemData.vatRate : 'none'))], _vm._v(" "), (_vm.formattedSettings) ? [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.taxCategory) + ": " + _vm._s(_vm.itemData.taxCategory))] : _vm._e(), _vm._v(" "), (_vm.itemData.minimumTotalPrice && _vm.isEdit) ? [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.defPrice) + ": " + _vm._s(_vm.itemData.minimumTotalPrice))] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "item-actions d-inline-block"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addItemTrigger()
      }
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addItemTrigger(true)
      }
    }
  }, [_vm._v("plus_one")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": [function($event) {
        $event.stopPropagation();
        return _vm.$emit('editItem', [
          [_vm.index], false
        ])
      }, function($event) {
        return _vm.showCurrent()
      }]
    }
  }, [_vm._v("edit")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('deleted', [
          [_vm.index], false
        ])
      }
    }
  }, [_vm._v("delete")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    staticClass: "copyItemClass",
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('copyItem', [
          [_vm.index], false
        ])
      }
    },
    slot: "activator"
  }, [_vm._v("file_copy")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$lang.actions.copyItem))])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    staticClass: "massAddClass",
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('massAdd', [
          [_vm.index], false
        ])
      }
    },
    slot: "activator"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$lang.actions.massAdd))])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    staticClass: "massRemoveClass",
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('massRemove', [
          [_vm.index], false
        ])
      }
    },
    slot: "activator"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$lang.actions.massRemove))])], 1), _vm._v(" "), (_vm.itemData.items && _vm.itemData.items.length > 0) ? _c('i', {
    staticClass: "material-icons",
    class: {
      'primary--text': _vm.itemData.open
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$set(_vm.itemData, 'open', !_vm.itemData.open)
      }
    }
  }, [_vm._v("folder_open")]) : _vm._e()], 1), _vm._v(" "), (_vm.itemData.items) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemData.open),
      expression: "itemData.open"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.itemData.items), function(item, index) {
    return _c('item', {
      key: index,
      attrs: {
        "index": index,
        "views": _vm.views,
        "isEdit": _vm.isEdit,
        "itemData": item,
        "items": _vm.itemData.items
      },
      on: {
        "addItem": function($event) {
          return _vm.selectFurther($event, 'addItem')
        },
        "editItem": function($event) {
          return _vm.selectFurther($event, 'editItem')
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        },
        "editItemPassing": _vm.editItemPassing,
        "deleted": function($event) {
          return _vm.selectFurther($event, 'deleted')
        },
        "copyItem": function($event) {
          return _vm.selectFurther($event, 'copyItem')
        },
        "massAdd": function($event) {
          return _vm.selectFurther($event, 'massAdd')
        },
        "massRemove": function($event) {
          return _vm.selectFurther($event, 'massRemove')
        },
        "selected": function($event) {
          return _vm.selectFurther($event, 'selected')
        }
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf5bb850","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalog/Item.vue
// module id = 432
// module chunks = 35